import activityConfig from "emun.activity/activity.config";
import authConfig from "emun.auth/auth.config";
import registerRetailerPrompt from "emun.auth/register-retailer-prompt";
import registerRetailerPromptFormIO from "emun.auth/register-retailer.prompt";
import Customer from "emun.cust/cust.model";
import filters from "emun.cust/list/cust-list.filters";
import sortOptions from "emun.cust/list/cust-list.sort-options";
import templates from "emun.cust/list/cust-list.templates";
import views from "emun.cust/list/cust-list.views";
import labels from "emun.customer/_labels";
import ContactPopup from "emun.customer/customer-contact.popover";
import ShipLocationPopup from "emun.customer/customer-shiplocation.popover";
import customerConfig from "emun.customer/customer.config";
import customerPicker from "emun.customer/picker/customer-picker";
import ScanBadge from "emun.customer/scan-badge/scan-badge";
import orderConfig from "emun.order/order.config";
import productPicker from "emun.products/picker/product-picker";
import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import $session from "servicestack/session";
import addressValidatorPrompt from "webutils/address-validator-prompt";
import retailerConfig from "emun.retailer/retailer.config";

// import customerPrompt from "emun.cust/cust-prompt";

export const DEFAULT_MODAL_OPTS = {
  placement: "left",
  size: "md",
  colSplit: 0,
};

export default class CustomerContainerController extends BasicAutoQueryController {
  getQuery() {
    const $ctrl = this;
    //console.debug("CustomerContainerController", $ctrl);
    $ctrl.ngModel = this;
    $ctrl.labels = labels;
    $ctrl.$session = $session;
    $ctrl.templates = templates;
    $ctrl.config = customerConfig;
    $ctrl.orderConfig = orderConfig;
    $ctrl.activityConfig = activityConfig;
    $ctrl.showInactive = false;
    $ctrl.prompt = $ctrl.$ioc("retailerPrompt");
    $ctrl.authConfig = authConfig;
    $ctrl.retailerConfig = retailerConfig;
    $ctrl.mode = "medium";
    $ctrl.$on("$stateChangeSuccess", (event, toState, { customerId } = {}) => {
      if (customerId) {
        $ctrl.customerId = customerId;
      }
    });
    return {
      url: "QueryRetailersJoin.json",
      tagTotalsUrl: `QueryRetailerTagTotals.json?RetailerIdsToTake=0&JsConfig=ExcludeDefaultValues`,
      pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
      disableQueryString: $ctrl.disableQueryString !== false,
      criteria: {
        status: "Active",
        op: "CustomerContainerController",
        includeSalesData: customerConfig.includeSalesData,
      },
      filters: $ctrl.filters || filters,
      fields: customerConfig.listFields,
      views: $ctrl.views || views,
      templates: $ctrl.templates || templates,
      view:
        $ctrl.layout ||
        Object.keys(views)[$ctrl.$pageConfig.is("gt-md") ? 0 : 1],
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      autoLoad: true,
      sortOptions,
      tagCriteria: Object.assign({}, $ctrl.tagCriteria, $ctrl.tags),
      orderBy: "Status,CompanyName,Id",
      scrub(res) {
        res.data.results = res.data.results.map((media) => new Customer(media));
      },
    };
  }

  startOrder(customer) {
    const $ctrl = this;
    //console.info("customer.paymentTermsId", customer, customer.paymentTerms);
    $ctrl.$cart.createPrompt({
      retailer: customer,
      paymentTermsId: customer.paymentTerms,
      status: "Cart",
    });
  }

  thumbnailConstrainTo() {
    const $ctrl = this;
    return $ctrl.isFullscreen
      ? 0
      : $ctrl.mode === "large"
      ? 600
      : $ctrl.mode === "medium"
      ? 300
      : 150;
  }

  editCustomer(media, options = DEFAULT_MODAL_OPTS) {
    console.debug("editCustomer", { media, options });
    const $ctrl = this;
    return customerPrompt({
      media,
      ...options,
    }).then(({ $delete, $deactivate, $update }) => {
      let promise = null;
      if ($delete) {
        promise = $ctrl.deleteCustomer($delete);
      } else if ($deactivate) {
        promise = $ctrl.toggleCustomer($deactivate);
      } else if ($update) {
        promise = $ctrl.bus.send("UpdateCustomer.json", {
          ...$update,
        });
      }
      if (promise) {
        return promise.then(() => $ctrl.query.load());
      }
    });
  }

  addCustomer() {
    const $ctrl = this;
    $ctrl.editCustomer({ position: $ctrl.query.total + 1 });
  }

  canManage() {
    const $ctrl = this;
    return !$ctrl.$session.isOffline(); //&&
    // $ctrl.$state.current.name.split(".")[0].endsWith("media-admin") &&
    // $ctrl.$session.hasPermission("ManageCustomer")
  }

  upload($files) {
    const $ctrl = this;
    if ($files && $files.length) {
      const req = {
        realm: $ctrl.realm,
        tags: $ctrl.query.getTagCriteria(),
      };

      return $ctrl.bus
        .upload("CreateCustomer.json", {
          request: req,
          files: $files,
        })
        .then(() => $ctrl.query.load(true));
    }
  }

  manageCustomerProducts(
    media,
    options = {
      ...DEFAULT_MODAL_OPTS,
      placement: "right",
      criteria: {
        op: "manageCustomerProducts",
        IncludeInactive: true,
      },
    }
  ) {
    const $ctrl = this;
    const {
      tags: { $skus: productIds = [] },
    } = media;
    return productPicker({
      title: "Manage product(s)...",
      applyTagsButtonText: false,
      single: false,
      viewSelections: productIds.length > 0,
      selected: productIds.reduce(
        (m, id) => Object.assign(m, { [id]: true }),
        {}
      ),
      // onProductSelected: (e) => $ctrl.productPickerOnProductSelected(e),
      ...options,
    }).then((result) =>
      $ctrl.bus
        .send("UpdateCustomer.json", {
          ...media,
          tags: { ...media.tags, $skus: Object.keys(result) },
        })
        .then(({ data: updated }) =>
          console.debug("ApplyCustomerTags", Object.assign(media, updated))
        )
    );
  }

  deleteCustomer(customer) {
    const $ctrl = this;
    return $ctrl.$modals
      .confirm(
        "Are you sure you want to delete customer ID: " +
          customer.id +
          " - Name: " +
          customer.companyName +
          "?",
        "Delete Customer"
      )
      .result.then(function () {
        $ctrl.bus
          .send("DeleteRetailer.json", customer)
          .then(function (response) {
            $ctrl.$emit("RetailerDeleted", $ctrl);
            $ctrl.query.load();
          });
      });
  }
  view(customer) {
    const $ctrl = this;
    $ctrl.$state.transitionTo("^.details", {
      customerId: customer.id,
    });
  }
  contactPopup(customer) {
    const $ctrl = this;
    ContactPopup.open({ customer: customer });
  }
  shipLocationPopup(customer) {
    const $ctrl = this;
    ShipLocationPopup.open({ customer: customer });
  }
  toggleInactive() {
    const $ctrl = this;
    if ($ctrl.showInactive) {
      $ctrl.showInactive = false;
      $ctrl.query.criteria.status = "Active";
    } else {
      $ctrl.showInactive = true;
      $ctrl.query.criteria.status = "";
    }
    $ctrl.query.load(true);
  }
  register() {
    const $ctrl = this;
    console.debug("register", $ctrl);
    if ($ctrl.authConfig.formIORegistration) {
      registerRetailerPromptFormIO({});
    } else {
      registerRetailerPrompt({}).then(function (args) {
        $ctrl.$state.go("^.details", {
          customerId: args.id || args.meta.RetailerId,
        });
      });
    }
  }

  create() {
    const $ctrl = this;
    return $ctrl.prompt.add().then((args) => $ctrl.onCreated(args));
  }

  start() {
    const $ctrl = this;
    return $ctrl.prompt.start().then((args) => $ctrl.onCreated(args));
  }

  onCreated(args) {
    const $ctrl = this;
    //console.info('customer args', args);
    $ctrl.$state.go("^.details", {
      customerId: args.id || args.meta.RetailerId,
    });
  }

  validateAddress(customer) {
    const $ctrl = this;
    addressValidatorPrompt
      .open({ model: customer, key: customer.id })
      .then(function (address) {
        if (address.valid && address.selected) {
          $ctrl.query.bus
            .send("QueryRetailers.json?Id=" + customer.id)
            .then(function (response) {
              if (response.data.results.length > 0) {
                customer = response.data.results[0];
                customer.companyName = address.selected.companyName;
                customer.address = address.selected.address;
                customer.address2 = address.selected.address2;
                customer.city = address.selected.city;
                customer.state = address.selected.state;
                customer.zip = address.selected.zip;
                customer.tags["latitude"] = address.selected.latitude;
                customer.tags["longitude"] = address.selected.longitude;
                $ctrl.query.bus
                  .send("UpdateRetailer", customer)
                  .then(function () {
                    $ctrl.query.load(true);
                  });
              }
            });
        }
      });
  }
  bulkActions(model) {
    const $ctrl = this;
    return customerPicker({
      title: "Select Customers...",
      view: "table",
      backdrop: false,
      placement: "center",
      criteria: $ctrl.query.criteria,
    }).finally(() => $ctrl.query.load(true));
  }
  scanBadge(model) {
    const $ctrl = this;
    ScanBadge.open({}).then(() => $ctrl.query.load());
  }
}
